import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { useSiteSettings } from '../../context/SiteSettingsContext';

const Header = () => {
  const { logout, user } = useAuth();
  const { settings } = useSiteSettings();

  return (
    <header className="admin-header">
      <nav className="admin-header__nav">
        <Link to="/" className="admin-header__brand">
          {settings?.text?.adminHeaderTitle || 'SifrifanaShop Admin'}
        </Link>
        <div className="admin-header__account">
          <span>Welcome, {user?.name}</span>
          <button
            onClick={logout}
            className="admin-header__logout"
          >
            Logout
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Header;




